import React from 'react';
import { TableDataCase } from '../TableDataCase';
import { Divider } from '../../../../atoms/Dividers/Divider';
import { ProfileInfoExtended } from '../../../../../types/user/user.def';

export interface TableDataLineUserProps {
  user: ProfileInfoExtended;
  toElevePage: () => void;
}

export const TableDataLineUser = ({
  user,
  toElevePage
}: TableDataLineUserProps) => {
  return (
    <>
      <tr>
        <TableDataCase
          variant={'data'}
          data={`${user?.lastname} ${user?.firstname}${
            user.role === 'professeur' ? '\u00A0🧑‍🏫' : ''
          }`}
        />
        <TableDataCase variant={'data'} data={user.email} />
        <TableDataCase variant={'data'} data={user.username} />
        <TableDataCase variant={'data'} data={user.mdp} />
        <TableDataCase onClick={toElevePage} variant={'icon'} icon={'Edit'} />
      </tr>
      <Divider color={'light'} margin={false} />
    </>
  );
};
